import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageProvider";

const IPGI = () => {

    console.log("------------------ipgi rendered----------------------");

    const navigate = useNavigate();

    const {translation} = useLanguage()

    const handleKeyPress = (event) => {
        if (event.key === " ") {
            navigate("/IPG");
        }
    };

    useEffect(() => {
        // Add event listener for key press
        window.addEventListener("keydown", handleKeyPress);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
            <h1 className="text-4xl mb-8 text-left w-full max-w-5xl ml-4" 
                dangerouslySetInnerHTML={{ __html: translation("IPGI_studyInstructions") }} 
            />
            <ul className="list-disc mb-8 w-full max-w-4xl ml-4 pl-2 text-left text-2xl">
                <li className="mb-2">{translation("IPGI_xPrompt")}</li>
                <li className="mb-2">{translation("IPGI_taskInstructions")}</li>
                <li className="mb-2">{translation("IPGI_taskInstructions2")}</li>
                <li className="mb-2">{translation("IPGI_speedAccuracyReminder")}</li>
                <li className="mb-2">{translation("IPGI_warningResponseSpeed")}</li>
            </ul>
            <h2 className="text-4xl mb-6 text-left w-full max-w-5xl ml-4">
                {translation("IPGI_beginPrompt")}
            </h2>
        </div>
    );
};

export default IPGI;
